import { get } from 'lodash-es';
import BulkActions from '../components/bulk-action/bulk-actions';
import { LogService } from '../services/log-service';

const componentMap = BulkActions.reduce((acc, curr) => {
  return {
    ...acc,
    [curr.id]: curr,
  };
}, {});

const getBulkAction = (bulkActionId) => {
  const foundComponent = componentMap[bulkActionId];
  if (!foundComponent) {
    LogService.logError(new Error('Unable to find bulk action'), {
      bulkActionId,
    });
    return null;
  }
  return foundComponent;
};

class BulkActionServiceClass {
  getComponent(bulkActionId) {
    return get(getBulkAction(bulkActionId), 'render', () => null);
  }

  getValidator(bulkActionId) {
    return get(getBulkAction(bulkActionId), 'getErrorsFromModel', () => undefined);
  }

  getModelErrors(bulkActions, model) {
    return bulkActions.reduce((acc, bulkAction) => {
      const errors = this.getValidator(bulkAction.name)(model);
      if (errors) {
        return {
          ...acc,
          [bulkAction.name]: errors,
        };
      }
      return acc;
    }, {});
  }
}

export const BulkActionService = new BulkActionServiceClass();
